import React, { useState } from "react";
import Joi from "joi-browser";
import Form from "../../components/Form";
import * as projectService from "../../services/projectService";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";

import PineconeIcon from "V2.0/images/pinecone.png";

function PineConeComponent({ projectId, settings, fetchSettings, isViewOnly }) {
  const [pineConeFields] = useState({
    pineconeIndex: settings?.vectorDbSettings?.pineconeSettings.pineconeIndex,
    pineconeEnvironment:
      settings?.vectorDbSettings?.pineconeSettings.pineconeEnvironment,
    pineconeKey: settings?.vectorDbSettings?.pineconeSettings.pineconeKey,
  });

  const [loading, setLoading] = useState(false);

  const [errorMessageZohoCRM] = useState({});

  const templateZohoCRM = [
    {
      name: "pineconeIndex",
      label: "Pinecone Index",
      type: "text",
      style: "",
      disabled: isViewOnly,
    },
    {
      name: "pineconeEnvironment",
      label: "Pinecone Environment",
      type: "text",
      style: "",
      disabled: isViewOnly,
    },
    {
      name: "pineconeKey",
      label: "Pinecone Key",
      type: "password",
      style: "",
      disabled: isViewOnly,
    },
  ];

  const buttonInfo = !isViewOnly
    ? {
        label: "Connect Pinecone",
        style: "entire-width",
      }
    : {};

  const schemaforPinecone = {
    pineconeIndex: Joi.string().max(5000).required().label("Pinecone Index"),
    pineconeEnvironment: Joi.string()
      .max(5000)
      .required()
      .label("Pinecone Environment"),
    pineconeKey: Joi.required().label("Pinecone Key"),
  };

  const handlePineConnection = async (data) => {
    setLoading(true);

    let newData = {
      pineconeSettings: {
        pineconeIndex: data.pineconeIndex,
        pineconeEnvironment: data.pineconeEnvironment,
        pineconeKey: data.pineconeEnvironment,
      },
    };

    try {
      const response = await projectService.updateProject(projectId, {
        vectorDbSettings: newData,
      });
      if (response.status === 200) {
        message.success("Pinecone Connected");
        setLoading(false);
        fetchSettings(projectId);
      }
    } catch (ex) {
      setLoading(false); // Ensure setLoading is defined and used correctly
      showErrorToast(ex, "Failed to connect");
    }
  };

  return (
    <div>
      <div className="p-8 rounded-lg border">
        <div className="flex gap-x-2 mb-4">
          <img
            src={PineconeIcon}
            width={24}
          />
          <h3 className="text-base font-semibold leading-6 text-gray-900">
            Connect Pinecone
          </h3>
        </div>

        <Form
          errorMessage={errorMessageZohoCRM}
          inputField={pineConeFields}
          template={templateZohoCRM}
          schema={schemaforPinecone}
          buttonInfo={buttonInfo}
          onSubmit={handlePineConnection}
          loading={loading}
          setLoading={setLoading}
        />
      </div>
    </div>
  );
}

export default PineConeComponent;
